(function() {
    'use strict';

    angular
        .module('ccsTrApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngLodash',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            // Smartadmin Angular Common Module
            'SmartAdmin',
            'ui.router',
            'ui.router.tabs',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.grid',
            'ui.grid.pagination',
            'ui.grid.selection',
            'ui.grid.edit',
            'ui.grid.validate',
            'ui.grid.autoResize',
            'ui.grid.resizeColumns',
            'xeditable',
            'ngAnimate',
            'ngFileUpload',
            'angularMoment',
            'ui.grid.cellNav',
            'angularMoment',
            'ngHandsontable',
            'toastr',
            'ct.ui.router.extras',
            'directive.contextMenu',
            'ui.utils.masks'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$rootScope', 'editableOptions', 'editableThemes', '$state'];

    function run(stateHandler, translationHandler, $rootScope, editableOptions, editableThemes, $state) {
        $rootScope.$state = $state;
        editableThemes.bs3.inputClass = 'input-sm';
        editableThemes.bs3.buttonsClass = 'btn-sm';
        editableOptions.theme = 'bs3';
        stateHandler.initialize();
        translationHandler.initialize();

        $rootScope.$on('handleEmit', function( event, args ) {
            $rootScope.$broadcast('handleBroadcast', args);
        });
    }
})();
